/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IBaseModalControllerScope extends angular.IScope {
        close: any;
        dismissModal: any;
    }

    export class BaseModalController implements IController {
        scope: IBaseModalControllerScope;

        constructor($scope: IBaseModalControllerScope, close: any) {
            this.scope = $scope;
            this.scope.close = close;
            this.scope.dismissModal = (result) => this.dismissModal(result);
        }

        protected dismissModal(result: any): void {
            this.scope.close(result, 200); // close, but give 200ms for bootstrap to animate
            setTimeout(function() {
                var body = jQuery('body');
                body.removeClass('modal-open');
                $('.modal-backdrop').remove();
                body.css("padding-right", "0");
            }, 201);
        }
    }
}